import React, { FC } from "react";
import { Helmet } from "react-helmet";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ScrollTop from "../../../components/ScrollToTop";
import { endOfTitle } from "../../../constants/constants";
import Loading from "../../../components/Loading";
import Error from "../../../components/Error";
import { UserRole } from "../../user/enums/UserRole";
import { useAuth } from "../../auth/hooks/useAuth";
import { useStudentApplications } from "../hooks/useStudentApplications";
import { StudentApplicationCard } from "./card/StudentApplicationCard";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "center",
  },
  loading: {
    "& > div": {
      position: "static",
      backgroundColor: "unset",
      padding: "280px 0",
    },
  },
  error: {
    marginTop: 200,
  },
}));

export const StudentApplications: FC<any> = ({ studentId }) => {
  const classes = useStyles();

  const { user } = useAuth();

  if (user.role === UserRole.Student) {
    studentId = user.id;
  }

  const { isLoading, applications } = useStudentApplications(studentId);

  return (
    <div className={classes.root}>
      <Helmet>
        <title>Applications{endOfTitle}</title>
      </Helmet>
      {isLoading ? (
        <div className={classes.loading}>
          <Loading />
        </div>
      ) : applications.length ? (
        <div>
          {applications.map((application) => (
            <StudentApplicationCard
              key={application.id}
              studentId={studentId}
              application={application}
            />
          ))}
        </div>
      ) : (
        <Error
          className={classes.error}
          fullHeight={false}
          text={"You have no submitted applications."}
        />
      )}
      <ScrollTop threshold={200} />
    </div>
  );
};
